<template lang="pug">
  b-card(class="mb-3")
    .doc-list-wrapper.mb-3
      .preloader(v-if="is_loading")
      document-item(v-for="(doc, i) in docs" :doc="doc.attributes" :can_delete="is_deletable")
      small.text-muted(v-if="docs.length == 0") Нет прикреплённых документов
    document-form(v-if="can_upload_files" :linked_id="linked_id" :linked_type="linked_type")
</template>

<script>
import DocumentItem from "./DocumentItem";
import DocumentForm from "./DocumentForm";
export default {
  name: "DocumentList",
  components: {DocumentForm, DocumentItem},
  props: {
    linked_type: {
      type: String,
      default: ''
    },
    linked_id: {
      type: [Number, String],
      default: 0,
    },
    role: {
      type: String,
      default: 'user',
    }
  },
  data(){
    return {
      form_shown: false,
      socket_state: undefined,
    }
  },
  computed: {
    docs() {
      return this.$store.getters[`docs/allDocs`];
    },
    list_state(){
      return this.$store.state.docs.list_state;
    },
    is_loading(){
      return this.list_state === 'loading'
    },
    is_deletable(){
      return this.role === 'user';
    },
    can_upload_files(){
      return this.role === 'user';
    },
  },
  channels: {
    SecureDocumentsChannel: {
      connected() {
        console.log('===== connected!');
        if (this.socket_state === 'disconnected') this.updateDocList();
        this.socket_state = 'connected'
      },
      rejected() {
        console.log('===== rejected!');
        this.socket_state = 'rejected'
      },
      received(data) {
        console.log('===== received.', data);
        let doc = data.doc.data;
        if (data.action === 'upload') {
          this.$store.commit('docs/addDoc', doc)
        }
        if (data.action === 'destroy') {
          this.$store.commit('docs/removeDoc', doc)
        }
      },
      disconnected() {
        console.log('===== disconnected!');
        this.socket_state = 'disconnected'
      },
    },
  },

  beforeMount() {
    this.$store.commit('docs/setListRole', this.role);
  },
  mounted() {
    this.updateDocList();
    this.$cable.subscribe({
      channel: 'SecureDocumentsChannel',
      linked_id: this.linked_id,
      linked_type: this.linked_type,
    });
  },
  methods:{
    updateDocList(){
      let promise = this.$store.dispatch(`docs/getDocs`, {
        linked_id: this.linked_id,
        linked_type: this.linked_type
      });
      promise.then(this.scroll_list_to_bottom);
    },
  }
}
</script>

<style scoped>

</style>